<div class="mb-5 lg:grid-cols-2 animate__animated animate__fadeInDown">
  <div class="panel space-y-5">
    <h5 class="mb-4 text-3xl font-semibold flex justify-center">{{ 'VEHICLES.PLATE' | translate }}</h5>
    <div class="flex justify-around">

        <!-- <input class="form-radio cursor-pointer ltr:mr-4 rtl:ml-4" type="radio" name="flexRadioDefault" /> -->
        <!-- <span>
            <img src="../../../../../../assets/images/plate2.png" alt="plate" class="w-36 h-36">
            <img class="ms-3"
            width="200"
            height="68"
            alt="settings-light"
            src="../../../../../../assets/images/car2.png"/>
         </span> -->
  </div>
  <div class="panel space-y-5 flex justify-center">
        <!-- <h5 class="mb-4 text-lg font-semibold">{{ 'VEHICLES.PLATE' | translate }}</h5> -->
        <app-platecity></app-platecity>
    </div>
</div>
<div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 pt-5 animate__animated animate__fadeInUp animate__delay-1s">
  <div *ngFor="let vehicle of vehicle" class="panel p-5 flex justify-center space-y-3 border rounded-lg shadow-md">
    <label class="inline-flex cursor-pointer">
        <!-- <input class="form-radio cursor-pointer ltr:mr-4 rtl:ml-4" type="radio" name="flexRadioDefault" checked /> -->
        <span>
            <img [src]="vehicle.plate" alt="plate" class="w-36 h-36 flex justify-center">
          <img
            class="ms-3 flex justify-center"
            width="200"
            height="68"
            alt="settings-dark"
            [src]="vehicle.car"
          />
        </span>
      </label>
  </div>
  </div>
  <app-list-vehicle></app-list-vehicle>
